// components/UI.jsx — all reusable primitives in one file
// Import: import { Button, Badge, Input, Modal, Card, StatCard } from './components/UI';
import { useEffect, useRef } from "react";
import cfg from "../config";

// ─── Icons (inline SVG) ───────────────────────────────────────────────────────
const svg =
  (d, extra = "") =>
  ({ size = 16, color }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color || "currentColor"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      dangerouslySetInnerHTML={{ __html: d }}
    />
  );

export const Icons = {
  Leaf: ({ size = 16, color }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color || "currentColor"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10z" />
      <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12" />
    </svg>
  ),
  Search: ({ size = 16, color }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color || "currentColor"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="11" cy="11" r="8" />
      <path d="m21 21-4.35-4.35" />
    </svg>
  ),
  Close: ({ size = 16, color }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color || "currentColor"}
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
  Menu: ({ size = 22, color }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color || "currentColor"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="3" y1="12" x2="21" y2="12" />
      <line x1="3" y1="6" x2="21" y2="6" />
      <line x1="3" y1="18" x2="21" y2="18" />
    </svg>
  ),
  Arrow: ({ size = 16, color }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color || "currentColor"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M5 12h14" />
      <path d="m12 5 7 7-7 7" />
    </svg>
  ),
  Check: ({ size = 16, color }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color || "currentColor"}
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="20 6 9 17 4 12" />
    </svg>
  ),
  Phone: ({ size = 16, color }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color || "currentColor"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.41 2 2 0 0 1 3.6 1.22h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.88a16 16 0 0 0 6.21 6.21l1.74-1.74a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
    </svg>
  ),
  Mail: ({ size = 16, color }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color || "currentColor"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="2" y="4" width="20" height="16" rx="2" />
      <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
    </svg>
  ),
  Pin: ({ size = 16, color }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color || "currentColor"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  ),
  Clock: ({ size = 16, color }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color || "currentColor"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  ),
  Plus: ({ size = 16, color }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color || "currentColor"}
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  ),
  Edit: ({ size = 14, color }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color || "currentColor"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
    </svg>
  ),
  Trash: ({ size = 14, color }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color || "currentColor"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="3 6 5 6 21 6" />
      <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
      <path d="M10 11v6" />
      <path d="M14 11v6" />
      <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
    </svg>
  ),
  Logout: ({ size = 16, color }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color || "currentColor"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <polyline points="16 17 21 12 16 7" />
      <line x1="21" y1="12" x2="9" y2="12" />
    </svg>
  ),
  Grid: ({ size = 16, color }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color || "currentColor"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="3" width="7" height="7" />
      <rect x="14" y="3" width="7" height="7" />
      <rect x="14" y="14" width="7" height="7" />
      <rect x="3" y="14" width="7" height="7" />
    </svg>
  ),
  Inbox: ({ size = 16, color }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color || "currentColor"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="22 12 16 12 14 15 10 15 8 12 2 12" />
      <path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
    </svg>
  ),
};

// ─── Button ───────────────────────────────────────────────────────────────────
const BTN_VARIANTS = {
  primary: {
    background: "var(--emerald)",
    color: "#fff",
    border: "none",
    boxShadow: "0 4px 18px rgba(30,122,60,.28)",
  },
  gold: {
    background: "linear-gradient(135deg,var(--honey),var(--amber))",
    color: "var(--forest)",
    border: "none",
    boxShadow: "0 4px 18px rgba(212,146,10,.32)",
    fontWeight: 700,
  },
  outline: {
    background: "transparent",
    color: "var(--emerald)",
    border: "1.5px solid var(--sage)",
  },
  ghost: {
    background: "rgba(58,158,88,.08)",
    color: "var(--pine)",
    border: "none",
  },
  dark: {
    background: "var(--forest)",
    color: "#fff",
    border: "none",
    boxShadow: "0 4px 18px rgba(0,0,0,.22)",
  },
  white: {
    background: "#fff",
    color: "var(--forest)",
    border: "none",
    boxShadow: "0 4px 16px rgba(0,0,0,.1)",
  },
  whatsapp: {
    background: "linear-gradient(135deg,#25d366,#128C7E)",
    color: "#fff",
    border: "none",
    boxShadow: "0 4px 18px rgba(37,211,102,.32)",
  },
  danger: {
    background: "transparent",
    color: "#dc2626",
    border: "1.5px solid #fca5a5",
  },
};
const BTN_SIZES = {
  sm: {
    padding: "7px 16px",
    fontSize: "12px",
    borderRadius: "8px",
    gap: "5px",
  },
  md: {
    padding: "11px 24px",
    fontSize: "14px",
    borderRadius: "10px",
    gap: "7px",
  },
  lg: {
    padding: "14px 32px",
    fontSize: "16px",
    borderRadius: "12px",
    gap: "9px",
  },
};

export const Button = ({
  children,
  variant = "primary",
  size = "md",
  onClick,
  loading = false,
  disabled = false,
  fullWidth = false,
  leftIcon,
  rightIcon,
  style = {},
}) => {
  const dis = disabled || loading;
  return (
    <button
      onClick={dis ? undefined : onClick}
      disabled={dis}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "var(--sans)",
        fontWeight: 600,
        letterSpacing: "-.01em",
        cursor: dis ? "not-allowed" : "pointer",
        opacity: dis ? 0.55 : 1,
        transition: "all .22s var(--ease)",
        whiteSpace: "nowrap",
        width: fullWidth ? "100%" : "auto",
        ...BTN_SIZES[size],
        ...BTN_VARIANTS[variant],
        ...style,
      }}
      onMouseEnter={(e) => {
        if (!dis) {
          e.currentTarget.style.transform = "translateY(-2px)";
          e.currentTarget.style.filter = "brightness(1.06)";
        }
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.filter = "brightness(1)";
      }}
    >
      {loading && (
        <span
          style={{
            width: 14,
            height: 14,
            border: "2px solid currentColor",
            borderTopColor: "transparent",
            borderRadius: "50%",
            animation: "spin .7s linear infinite",
            flexShrink: 0,
          }}
        />
      )}
      {!loading && leftIcon && (
        <span style={{ display: "flex", flexShrink: 0 }}>{leftIcon}</span>
      )}
      {children}
      {!loading && rightIcon && (
        <span style={{ display: "flex", flexShrink: 0 }}>{rightIcon}</span>
      )}
    </button>
  );
};

// ─── Badge ────────────────────────────────────────────────────────────────────
const BADGE_COLORS = {
  green: { bg: "#dcfce7", text: "#166534", border: "#bbf7d0" },
  amber: { bg: "#fef9c3", text: "#854d0e", border: "#fde68a" },
  red: { bg: "#fee2e2", text: "#991b1b", border: "#fca5a5" },
  forest: { bg: "var(--forest)", text: "#fff", border: "transparent" },
  gray: { bg: "#f3f4f6", text: "#374151", border: "#d1d5db" },
};
export const Badge = ({
  children,
  color = "green",
  dot = false,
  style = {},
}) => {
  const c = BADGE_COLORS[color] || BADGE_COLORS.green;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 5,
        background: c.bg,
        color: c.text,
        border: `1px solid ${c.border}`,
        padding: "3px 10px",
        borderRadius: 6,
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: 0.4,
        whiteSpace: "nowrap",
        ...style,
      }}
    >
      {dot && (
        <span
          style={{
            width: 5,
            height: 5,
            borderRadius: "50%",
            background: c.text,
            display: "inline-block",
            flexShrink: 0,
          }}
        />
      )}
      {children}
    </span>
  );
};

// ─── Input ────────────────────────────────────────────────────────────────────
export const Input = ({
  label,
  name,
  value,
  onChange,
  placeholder,
  type = "text",
  as = "input",
  rows = 4,
  required = false,
  error,
  leftIcon,
  children,
  style = {},
  ...rest
}) => {
  const Tag =
    as === "textarea" ? "textarea" : as === "select" ? "select" : "input";
  return (
    <div style={{ position: "relative", width: "100%" }}>
      {label && (
        <label
          style={{
            display: "block",
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: 1,
            textTransform: "uppercase",
            color: error ? "#dc2626" : "var(--stone)",
            marginBottom: 7,
          }}
        >
          {label}
          {required && (
            <span style={{ color: "#dc2626", marginLeft: 3 }}>*</span>
          )}
        </label>
      )}
      <div style={{ position: "relative" }}>
        {leftIcon && (
          <span
            style={{
              position: "absolute",
              left: 14,
              top: "50%",
              transform: "translateY(-50%)",
              color: "var(--stone)",
              display: "flex",
              pointerEvents: "none",
            }}
          >
            {leftIcon}
          </span>
        )}
        <Tag
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          type={as === "input" ? type : undefined}
          rows={as === "textarea" ? rows : undefined}
          required={required}
          className="field"
          style={{
            paddingLeft: leftIcon ? 44 : 16,
            border: `1.5px solid ${error ? "#fca5a5" : "var(--mist)"}`,
            resize: as === "textarea" ? "vertical" : "none",
            ...style,
          }}
          onFocus={(e) => {
            e.currentTarget.style.borderColor = error
              ? "#ef4444"
              : "var(--sage)";
            e.currentTarget.style.boxShadow = `0 0 0 3px rgba(${error ? "239,68,68" : "58,158,88"},.12)`;
          }}
          onBlur={(e) => {
            e.currentTarget.style.borderColor = error
              ? "#fca5a5"
              : "var(--mist)";
            e.currentTarget.style.boxShadow = "none";
          }}
          {...rest}
        >
          {as === "select" ? children : undefined}
        </Tag>
      </div>
      {error && (
        <p
          style={{
            fontSize: 12,
            color: "#dc2626",
            marginTop: 5,
            fontWeight: 500,
          }}
        >
          {error}
        </p>
      )}
    </div>
  );
};

// ─── Modal ────────────────────────────────────────────────────────────────────
export const Modal = ({
  isOpen,
  onClose,
  title,
  subtitle,
  size = "md",
  children,
  footer,
}) => {
  useEffect(() => {
    if (!isOpen) return;
    const fn = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", fn);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", fn);
      document.body.style.overflow = "";
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  const maxW = { sm: 380, md: 480, lg: 640 }[size];
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 2000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
      }}
    >
      <div
        onClick={onClose}
        style={{
          position: "absolute",
          inset: 0,
          background: "rgba(0,0,0,.55)",
          backdropFilter: "blur(6px)",
          animation: "fadeIn .2s ease both",
        }}
      />
      <div
        role="dialog"
        aria-modal="true"
        className="scale-in"
        style={{
          position: "relative",
          background: "#fff",
          borderRadius: 24,
          width: "100%",
          maxWidth: maxW,
          maxHeight: "90vh",
          display: "flex",
          flexDirection: "column",
          boxShadow: "0 40px 80px rgba(0,0,0,.25)",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            padding: "26px 28px 18px",
            borderBottom: "1px solid var(--foam)",
          }}
        >
          <div>
            {title && (
              <h3
                style={{
                  fontFamily: "var(--serif)",
                  fontSize: 22,
                  color: "var(--ink)",
                  letterSpacing: "-.01em",
                }}
              >
                {title}
              </h3>
            )}
            {subtitle && (
              <p style={{ fontSize: 13, color: "var(--stone)", marginTop: 3 }}>
                {subtitle}
              </p>
            )}
          </div>
          <button
            onClick={onClose}
            style={{
              background: "var(--foam)",
              border: "none",
              borderRadius: 10,
              width: 34,
              height: 34,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              color: "var(--stone)",
              flexShrink: 0,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "var(--mist)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "var(--foam)";
            }}
          >
            <Icons.Close size={15} />
          </button>
        </div>
        <div style={{ flex: 1, padding: "22px 28px", overflowY: "auto" }}>
          {children}
        </div>
        {footer && (
          <div
            style={{
              padding: "14px 28px 22px",
              borderTop: "1px solid var(--foam)",
            }}
          >
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};

// ─── Card ─────────────────────────────────────────────────────────────────────
export const Card = ({
  children,
  hoverable = false,
  padding = "22px",
  onClick,
  style = {},
}) => (
  <div
    onClick={onClick}
    className={hoverable ? "card" : ""}
    style={{
      background: "#fff",
      borderRadius: 16,
      border: "1px solid rgba(0,0,0,.07)",
      boxShadow: "var(--shadow-sm)",
      padding,
      overflow: "hidden",
      cursor: onClick ? "pointer" : "default",
      ...style,
    }}
  >
    {children}
  </div>
);

// ─── StatCard ─────────────────────────────────────────────────────────────────
export const StatCard = ({ icon, value, label, change, trend }) => (
  <div
    style={{
      background: "#fff",
      borderRadius: 16,
      border: "1px solid rgba(0,0,0,.07)",
      boxShadow: "var(--shadow-sm)",
      padding: "20px",
    }}
  >
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        marginBottom: 14,
      }}
    >
      <div
        style={{
          width: 42,
          height: 42,
          borderRadius: 12,
          background: "var(--foam)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 22,
        }}
      >
        {icon}
      </div>
      {trend && (
        <span
          style={{
            fontSize: 11,
            fontWeight: 700,
            color: trend === "up" ? "#16a34a" : "#dc2626",
            background: trend === "up" ? "#dcfce7" : "#fee2e2",
            padding: "2px 8px",
            borderRadius: 20,
          }}
        >
          {trend === "up" ? "↑" : "↓"}
        </span>
      )}
    </div>
    <div
      style={{
        fontFamily: "var(--serif)",
        fontSize: 30,
        color: "var(--ink)",
        lineHeight: 1,
      }}
    >
      {value}
    </div>
    <div
      style={{
        fontSize: 12,
        color: "var(--stone)",
        marginTop: 5,
        fontWeight: 500,
      }}
    >
      {label}
    </div>
    {change && (
      <div style={{ fontSize: 11, color: "#16a34a", marginTop: 3 }}>
        {change}
      </div>
    )}
  </div>
);

// ─── Logo ─────────────────────────────────────────────────────────────────────
// Reads company name + icon from config.js
// logoIcon can be:  an emoji  →  '🌱'
//                  an image   →  '/logo.png'  (file in public/ folder)
const isImageUrl = (v) =>
  typeof v === "string" && (v.startsWith("/") || v.startsWith("http"));
export const Logo = ({ inverted = false, onClick }) => (
  <div
    onClick={onClick}
    style={{
      display: "flex",
      alignItems: "center",
      gap: 11,
      cursor: onClick ? "pointer" : "default",
    }}
  >
    <div
      style={{
        width: 38,
        height: 38,
        borderRadius: 10,
        flexShrink: 0,
        background: inverted
          ? "rgba(255,255,255,.12)"
          : "linear-gradient(135deg,var(--pine),var(--emerald))",
        border: inverted ? "1.5px solid rgba(255,255,255,.2)" : "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: inverted ? "none" : "0 4px 12px rgba(30,122,60,.3)",
        overflow: "hidden",
      }}
    >
      {isImageUrl(cfg.logoIcon) ? (
        <img
          src={cfg.logoIcon}
          alt={cfg.companyFull}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      ) : (
        <span style={{ fontSize: 19 }}>{cfg.logoIcon}</span>
      )}
    </div>
    <div>
      <div
        style={{
          fontFamily: "var(--serif)",
          fontSize: 16,
          color: inverted ? "#fff" : "var(--forest)",
          lineHeight: 1.15,
        }}
      >
        {cfg.companyLine1}
      </div>
      <div
        style={{
          fontSize: 9,
          fontWeight: 700,
          letterSpacing: "2.5px",
          textTransform: "uppercase",
          color: inverted ? "var(--amber)" : "var(--honey)",
          lineHeight: 1.3,
        }}
      >
        {cfg.companyLine2}
      </div>
    </div>
  </div>
);

// ─── PageHeader ───────────────────────────────────────────────────────────────
export const PageHeader = ({ title, subtitle, crumb }) => (
  <div
    style={{
      paddingTop: "calc(var(--nav-h) + 60px)",
      paddingBottom: 56,
      background: "linear-gradient(160deg,var(--forest),var(--pine))",
      position: "relative",
      overflow: "hidden",
    }}
  >
    <div
      style={{
        position: "absolute",
        inset: 0,
        backgroundImage:
          "radial-gradient(circle at 30% 70%,rgba(58,158,88,.15) 0%,transparent 50%)",
        pointerEvents: "none",
      }}
    />
    <div className="wrap" style={{ position: "relative" }}>
      {crumb && (
        <div
          style={{
            fontSize: 12,
            color: "rgba(255,255,255,.4)",
            marginBottom: 14,
            display: "flex",
            alignItems: "center",
            gap: 6,
          }}
        >
          <span>{crumb[0]}</span>
          <span>›</span>
          <span style={{ color: "rgba(255,255,255,.7)" }}>{crumb[1]}</span>
        </div>
      )}
      <h1
        className="h-xl"
        style={{ color: "#fff", marginBottom: subtitle ? 10 : 0 }}
      >
        {title}
      </h1>
      {subtitle && (
        <p
          style={{
            fontSize: 16,
            color: "rgba(255,255,255,.6)",
            fontWeight: 300,
            maxWidth: 480,
          }}
        >
          {subtitle}
        </p>
      )}
      <div
        className="divider"
        style={{
          background: "linear-gradient(90deg,var(--sage),var(--amber))",
        }}
      />
    </div>
  </div>
);
